// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/partner_register/common/v1/organization.proto

/* eslint-disable */
import { ApiTimestamp } from "../../../../../google/protobuf/timestamp";

/** Organization type */
export const ApiEntityType = {
  /** ENTITY_TYPE_UNSPECIFIED - Unspecified entity type */
  ENTITY_TYPE_UNSPECIFIED: "ENTITY_TYPE_UNSPECIFIED",
  /**
   * Freelancer
   */
  freelancer: "freelancer",
  /**
   * Company
   */
  company: "company",
} as const;

export type ApiEntityType = typeof ApiEntityType[keyof typeof ApiEntityType];

export namespace ApiEntityType {
  export type ENTITY_TYPE_UNSPECIFIED = typeof ApiEntityType.ENTITY_TYPE_UNSPECIFIED;
  export type freelancer = typeof ApiEntityType.freelancer;
  export type company = typeof ApiEntityType.company;
}

export function apiEntityTypeFromJSON(object: any): ApiEntityType {
  switch (object) {
    case 0:
    case "ENTITY_TYPE_UNSPECIFIED":
      return ApiEntityType.ENTITY_TYPE_UNSPECIFIED;
    case 1:
    case "freelancer":
      return ApiEntityType.freelancer;
    case 2:
    case "company":
      return ApiEntityType.company;
    default:
      return ApiEntityType.ENTITY_TYPE_UNSPECIFIED;
  }
}

export function apiEntityTypeToJSON(object: ApiEntityType): string {
  switch (object) {
    case ApiEntityType.ENTITY_TYPE_UNSPECIFIED:
      return "ENTITY_TYPE_UNSPECIFIED";
    case ApiEntityType.freelancer:
      return "freelancer";
    case ApiEntityType.company:
      return "company";
    default:
      return "ENTITY_TYPE_UNSPECIFIED";
  }
}

/** Classification of entity type for FATCA/CRS regulatory reporting */
export const ApiBusinessActivityEntityType = {
  /** BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED - Unspecified business activity entity type */
  BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED: "BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED",
  /**
   * Active Non-Financial Entity
   */
  active_nfe: "active_nfe",
  /**
   * Passive Non-Financial Entity
   */
  passive_nfe: "passive_nfe",
  /**
   * Financial Institution
   */
  financial_institution: "financial_institution",
} as const;

export type ApiBusinessActivityEntityType =
  typeof ApiBusinessActivityEntityType[keyof typeof ApiBusinessActivityEntityType];

export namespace ApiBusinessActivityEntityType {
  export type BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED =
    typeof ApiBusinessActivityEntityType.BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED;
  export type active_nfe = typeof ApiBusinessActivityEntityType.active_nfe;
  export type passive_nfe = typeof ApiBusinessActivityEntityType.passive_nfe;
  export type financial_institution = typeof ApiBusinessActivityEntityType.financial_institution;
}

export function apiBusinessActivityEntityTypeFromJSON(object: any): ApiBusinessActivityEntityType {
  switch (object) {
    case 0:
    case "BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED":
      return ApiBusinessActivityEntityType.BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED;
    case 1:
    case "active_nfe":
      return ApiBusinessActivityEntityType.active_nfe;
    case 2:
    case "passive_nfe":
      return ApiBusinessActivityEntityType.passive_nfe;
    case 3:
    case "financial_institution":
      return ApiBusinessActivityEntityType.financial_institution;
    default:
      return ApiBusinessActivityEntityType.BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED;
  }
}

export function apiBusinessActivityEntityTypeToJSON(object: ApiBusinessActivityEntityType): string {
  switch (object) {
    case ApiBusinessActivityEntityType.BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED:
      return "BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED";
    case ApiBusinessActivityEntityType.active_nfe:
      return "active_nfe";
    case ApiBusinessActivityEntityType.passive_nfe:
      return "passive_nfe";
    case ApiBusinessActivityEntityType.financial_institution:
      return "financial_institution";
    default:
      return "BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED";
  }
}

/** Organization represents an organization during the partner registration process */
export interface ApiOrganization {
  /** Unique identifier of the organization */
  readonly id: string;
  /** Organization's legal name */
  readonly legalName?:
    | string
    | null
    | undefined;
  /** Two-letter ISO 3166-1 country code */
  readonly legalCountry?:
    | string
    | null
    | undefined;
  /** Organization's legal form (e.g. SAS, SARL, GMBH, UG) */
  readonly legalForm?:
    | string
    | null
    | undefined;
  /** Organization's registration date */
  readonly legalRegistrationDate?:
    | string
    | null
    | undefined;
  /** Organization's registration number (e.g. SIRET in France) */
  readonly legalNumber?:
    | string
    | null
    | undefined;
  /** Organization legal sector code (e.g. INSEE NAF code) */
  readonly legalSector?:
    | string
    | null
    | undefined;
  /** Organization's VAT number */
  readonly legalVatNumber?:
    | string
    | null
    | undefined;
  /** Organization type */
  readonly entityType: ApiEntityType;
  /** Turnover for the past year */
  readonly annualTurnover?:
    | string
    | null
    | undefined;
  /** Estimated number of transactions per year */
  readonly yearlyTransactionVolume?:
    | string
    | null
    | undefined;
  /** Estimated highest amount for a single payment */
  readonly maxSinglePaymentAmount?:
    | number
    | null
    | undefined;
  /** Indicates what the Qonto account will be used for */
  readonly natureOfOperations: readonly string[];
  /** Creation timestamp */
  readonly createdAt:
    | Date
    | null;
  /** List of active features for the organization */
  readonly features: readonly string[];
  /** Classification of the entity type for FATCA/CRS regulatory reporting */
  readonly businessActivityEntityType: ApiBusinessActivityEntityType;
  /** Whether any beneficial owners have been declared as Politically Exposed Persons */
  readonly declaredPepInBeneficiaries: boolean;
}

export const ApiOrganization: MessageFns<ApiOrganization> = {
  fromJSON(object: any): ApiOrganization {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      legalName: isSet(object.legal_name) ? globalThis.String(object.legal_name) : null,
      legalCountry: isSet(object.legal_country) ? globalThis.String(object.legal_country) : null,
      legalForm: isSet(object.legal_form) ? globalThis.String(object.legal_form) : null,
      legalRegistrationDate: isSet(object.legal_registration_date)
        ? globalThis.String(object.legal_registration_date)
        : null,
      legalNumber: isSet(object.legal_number) ? globalThis.String(object.legal_number) : null,
      legalSector: isSet(object.legal_sector) ? globalThis.String(object.legal_sector) : null,
      legalVatNumber: isSet(object.legal_vat_number) ? globalThis.String(object.legal_vat_number) : null,
      entityType: isSet(object.entity_type)
        ? apiEntityTypeFromJSON(object.entity_type)
        : ApiEntityType.ENTITY_TYPE_UNSPECIFIED,
      annualTurnover: isSet(object.annual_turnover) ? globalThis.String(object.annual_turnover) : null,
      yearlyTransactionVolume: isSet(object.yearly_transaction_volume)
        ? globalThis.String(object.yearly_transaction_volume)
        : null,
      maxSinglePaymentAmount: isSet(object.max_single_payment_amount)
        ? globalThis.Number(object.max_single_payment_amount)
        : null,
      natureOfOperations: globalThis.Array.isArray(object?.nature_of_operations)
        ? object.nature_of_operations.map((e: any) => globalThis.String(e))
        : [],
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : null,
      features: globalThis.Array.isArray(object?.features)
        ? object.features.map((e: any) => globalThis.String(e))
        : [],
      businessActivityEntityType: isSet(object.business_activity_entity_type)
        ? apiBusinessActivityEntityTypeFromJSON(object.business_activity_entity_type)
        : ApiBusinessActivityEntityType.BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED,
      declaredPepInBeneficiaries: isSet(object.declared_pep_in_beneficiaries)
        ? globalThis.Boolean(object.declared_pep_in_beneficiaries)
        : false,
    };
  },

  toJSON(message: ApiOrganization): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.legalName !== undefined && message.legalName !== null) {
      obj.legal_name = message.legalName;
    }
    if (message.legalCountry !== undefined && message.legalCountry !== null) {
      obj.legal_country = message.legalCountry;
    }
    if (message.legalForm !== undefined && message.legalForm !== null) {
      obj.legal_form = message.legalForm;
    }
    if (message.legalRegistrationDate !== undefined && message.legalRegistrationDate !== null) {
      obj.legal_registration_date = message.legalRegistrationDate;
    }
    if (message.legalNumber !== undefined && message.legalNumber !== null) {
      obj.legal_number = message.legalNumber;
    }
    if (message.legalSector !== undefined && message.legalSector !== null) {
      obj.legal_sector = message.legalSector;
    }
    if (message.legalVatNumber !== undefined && message.legalVatNumber !== null) {
      obj.legal_vat_number = message.legalVatNumber;
    }
    if (message.entityType !== undefined && message.entityType !== null) {
      obj.entity_type = apiEntityTypeToJSON(message.entityType);
    }
    if (message.annualTurnover !== undefined && message.annualTurnover !== null) {
      obj.annual_turnover = message.annualTurnover;
    }
    if (message.yearlyTransactionVolume !== undefined && message.yearlyTransactionVolume !== null) {
      obj.yearly_transaction_volume = message.yearlyTransactionVolume;
    }
    if (message.maxSinglePaymentAmount !== undefined && message.maxSinglePaymentAmount !== null) {
      obj.max_single_payment_amount = Math.round(message.maxSinglePaymentAmount);
    }
    if (message.natureOfOperations?.length) {
      obj.nature_of_operations = message.natureOfOperations;
    }
    if (message.createdAt !== undefined && message.createdAt !== null) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.features?.length) {
      obj.features = message.features;
    }
    if (message.businessActivityEntityType !== undefined && message.businessActivityEntityType !== null) {
      obj.business_activity_entity_type = apiBusinessActivityEntityTypeToJSON(message.businessActivityEntityType);
    }
    if (message.declaredPepInBeneficiaries !== undefined && message.declaredPepInBeneficiaries !== null) {
      obj.declared_pep_in_beneficiaries = message.declaredPepInBeneficiaries;
    }
    return obj;
  },
};

function fromTimestamp(t: ApiTimestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(ApiTimestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
